/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import Reflux from "reflux";
import createReactClass from "create-react-class";
import classnames from "classnames";

import Store from "okpay/stores/Store";
import Actions from "okpay/actions/Actions";

import HasInfoSummary from "okpay/components/HasInfoSummary";
import Nav from "okpay/components/Nav";
import Body from "okpay/components/Body";
import OkLoader from "shared/components/OkLoader";

import $ from "jquery";

import "./App.scss";

const OkPayApp = createReactClass({
	displayName: "OkPayApp",
	mixins: [Reflux.ListenerMixin],

	getInitialState() {
		return this._getState();
	},

	componentDidMount() {
		this.listenTo(Store, this._onStoreChange);
		Actions.open();
	},

	componentWillUnmount() {
		Actions.close();
	},

	_onStoreChange(bundle) {
		const nextState = this._getState();
		this.setState(nextState);
	},

	_getState() {
		const storeState = Store.getAll();
		return storeState;
	},

	render() {
		// render nothing if the app is inactive
		let appBody;
		let appType;

		if (!this.state.isActive) {
			return null;
		}

		if (this.state.isLoading) {
			appBody = <OkLoader show={true} size="medium" />;
			appType = "loading";
		} else if (
			this.state.useBillingInfo &&
        this.state.useBillingInfo === this.state.billingType
		) {
			appBody = <HasInfoSummary {...this.state} />;
			appType = "useinfo";
		} else {
			appBody = (
				<div className="okpay-full">
					<Nav {...this.state} />
					<Body {...this.state} />
				</div>
			);

			appType = this.state.billingType;
		}

		const classMap = {
			"okpay-app": true,
			"okpay-app--update": this.state.productId === "update",
		};
		classMap[`okpay-app--${appType}`] = true;

		return (
			<div className={classnames(classMap)} ref="app">
				{appBody}
			</div>
		);
	},
});

export default OkPayApp;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/App.jsx